"use strict";


///
///   common utils
///
var utils_api =  {


  'frozenMerge' : function frozenMerge( ...i )  {
    return Object.freeze( Object.assign( {}, ...i ) );
  },


  'getStored' : function getStored( path, def )  {
    let itemJSON = window.localStorage.getItem( ""+path );
    if ( !itemJSON )
    {
      if ( def === undefined )
        def = null;
      itemJSON = JSON.stringify( def );
      window.localStorage.setItem( ""+path, itemJSON );
    }

    return JSON.parse(itemJSON);
  },


  'setStored' : function setStored( path, val )  {
    if ( val === undefined )
      val = null;
    let itemJSON = JSON.stringify( val );
    window.localStorage.setItem( ""+path, itemJSON );
    return JSON.parse(itemJSON);
  },


  'sheduleReload' : function sheduleReload()  {
    setTimeout( () => {
      window.location.reload();
      window.location.search="";
    }, 0 );
  },


};    //    utils_api namespace



function LogStream( stream )  {
  if ( !LogStream.streams[ stream ] )
    LogStream.streams[ stream ] = new LogStreamHolder( stream );

  return LogStream.streams[ stream ];
}


LogStream.streams = {};  //  static


LogStream.enable = ( ...streams ) =>  {
    streams.forEach( ( stream ) => LogStream( stream ).enabled = true );
  }


LogStream.disable = ( ...streams ) =>  {
    streams.forEach( ( stream ) => LogStream( stream ).enabled = false );
  }


class LogStreamHolder  {
  constructor( stream )  {
    this.stream = stream;
    this.streamMark = `[${stream}]`;
    this.enabled = false;

    // arrow-bound "methods"
    this.debug = ( ...rest ) =>  {
        this.shout((...x)=> console.debug(...x),  ...rest );
        return this.debug;
      }
    this.log = ( ...rest ) =>  {
        this.shout((...x)=>console.log(...x),  ...rest );
        return this.log;
      }
    this.info = ( ...rest ) =>  {
        this.shout((...x)=>console.info(...x),  ...rest );
        return this.info;
      }
    this.error = ( ...rest ) =>  {
        this.shout((...x)=>console.error(...x),  ...rest );
        return this.error;
      }
    this.warning = ( ...rest ) =>  {
        this.shout((...x)=>console.warn(...x),  ...rest );
        return this.warning;
      }
  }


  shout(handler, ...rest )  {
    if ( this.enabled )
      handler( this.streamMark, ...rest );
  }


};



